<template>
  <page>
    <v-card>
      <v-card-text>
        <v-form>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="docForm.polNo"
                  :label="labels.polNo"
                  :error-messages="errors.collect('polNo')"
                  data-vv-name="polNo"
                  :data-vv-as="labels.polNo"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('polNo')"
                  v-validate="'required'"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="docForm.renCnt"
                  :label="labels.renCnt"
                  :error-messages="errors.collect('renCnt')"
                  v-int-mask="{ intScale: 2 }"
                  data-vv-name="renCnt"
                  :data-vv-as="labels.renCnt"
                  v-validate="'required|numeric'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="docForm.endtCnt"
                  :label="labels.endtCnt"
                  :error-messages="errors.collect('endtCnt')"
                  v-int-mask="{ intScale: 2 }"
                  data-vv-name="endtCnt"
                  :data-vv-as="labels.endtCnt"
                  v-validate="'required|numeric'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="docForm.copy"
                  :label="labels.copy"
                  :error-messages="errors.collect('copy')"
                  v-int-mask="{ intScale: 2 }"
                  data-vv-name="copy"
                  :data-vv-as="labels.copy"
                  v-validate="'required|numeric'"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-autocomplete
                  :items="printSections"
                  v-model="docForm.printSection"
                  :label="labels.printSection"
                  item-text="label"
                  item-value="value"
                  data-vv-name="printSection"
                  :data-vv-as="labels.printSection"
                  :error-messages="errors.collect('printSection')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 class="pt-3">
                <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{ labels.export }}
                </v-btn>
                <v-btn-toggle dense mandatory v-model="docForm.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{ format.label }}</span>
                    <v-icon :color="format.color">{{ format.icon }}</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-dialog v-model="filterList" width="900px" persistent>
          <policy-helplist v-if="polMasterList" :apiURI="menu.getPolMasterList" @select="doAssign($event)" @close="doClose"></policy-helplist>
        </v-dialog>
      </v-card-text>
    </v-card>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import PolicyHelplist from './PolMasterHelplist'

export default {
  data() {
    return {
      labels: {
        polNo: 'Policy Number',
        renCnt: 'Renewal Count',
        endtCnt: 'Endorsement Count',
        copy: 'Number of Copy',
        format: 'Export Format',
        printSection: 'Print Section',
        export: 'Export to'
      },
      docForm: {
        polNo: null,
        renCnt: 0,
        endtCnt: 0,
        copy: 1,
        printSection: 0,
        format: 'PDF'
      },
      menu: {},
      supportedFormat: [],
      filterList: false,
      submitting: false,
      polMasterFields: [
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Renewal Count', value: 'renCnt' },
        { text: 'Endorsement Count', value: 'endtCnt' }
      ],
      printSections: [
        { label: 'Both', value: 0 },
        { label: 'RI Closing', value: 1 },
        { label: 'Coinsurance Slip', value: 2 }
      ],
      polMasterList: false
    }
  },
  computed: {
    riMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.docForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await this.$store.dispatch('riReportsInit')
        }
        const apiURI = this.riMenu.RIClosing
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList() {
      this.filterList = true
      this.polMasterList = true
    },
    doAssign(data) {
      this.docForm.polNo = data.polNo
      this.docForm.renCnt = data.renCnt
      this.docForm.endtCnt = data.endtCnt
      this.filterList = false
    },
    doClose() {
      this.filterList = false
      setTimeout(() => {
        this.polMasterList = false
      }, 200)
    },
    doExport() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const apiURI = this.menu.export
          this.submitting = true
          if (apiURI) {
            this.$http
              .post(apiURI, this.docForm)
              .then((result) => {
                this.submitting = false
              })
              .catch((err) => {
                this.submitting = false
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        }
      })
    }
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin],
  components: {
    PolicyHelplist
  }
}
</script>
